import { UiModalModel } from "../../models";

import { mockUiImageModel } from "./mock-ui-image";
import { mockUiVideoPlayerModel } from "./mock-ui-video-player";

export function mockUiModalModel({
    id = "modal-1234",
    type = "uiModal",
    locale = "en",
    content = mockUiModalModelContent()
}: Partial<UiModalModel> = {}): UiModalModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiModalModelContent = UiModalModel["content"];

export function mockUiModalModelContent({
    title = "Example modal",
    modalTrigger = mockUiImageModel(),
    modalContent = mockUiVideoPlayerModel(),
    ...optionals
}: Partial<UiModalModelContent> = {}): UiModalModelContent {
    return {
        title,
        modalTrigger,
        modalContent,
        ...optionals
    };
}
